import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: theme.spacing(2),
        width: '100%',
    },
    uploadBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '60%',
        maxWidth: '50rem',
        height: '12rem',
        border: '2px dashed',
        borderColor: '#142C5C',
        borderRadius: '10px',
        backgroundColor: theme.palette.background.paper,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.grey[100],
        },
    },
    uploadIcon: {
        fontSize: 40,
        color: '#142C5C',
        marginBottom: theme.spacing(1),
    },
    instructions: {
        fontSize: '13px !important',
        fontWeight: '500 !important',
        marginTop: "5px !important",
        color: 'rgba(0, 0, 0, 0.4) !important'
    },
    commands: {
        fontSize: '12px',
        fontWeight: 500,
    },
    commandsTitle: {
        fontSize: '18px !important',
        fontWeight: 600,
    },
    icon: {
        fontSize: 40,
        color: '#142C5C',
        marginBottom: theme.spacing(1),
    },
    dropzone: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '50rem',
        height: '16rem',
        border: '2px dashed',
        borderColor: '#142C5C',
        borderRadius: '10px',
        backgroundColor: theme.palette.background.paper,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.grey[100],
        },
    },
    buttonStyle: {
        padding: '6px 16px',
        backgroundColor: '#142C5C',
        color: '#fff',
        borderColor: '#0f2247',
        '&:hover': {
            backgroundColor: '#0f2247 !important',
        },
        '&:disabled': {
            opacity: 0.5,
            color: 'white !important',
            backgroundColor: '#142C5C !important',
        },
        borderRadius: '6px !important',
        fontSize: '14px',
        height: '40px',
        marginY: '10px'
    },
}));

export default useStyles;
